import { render } from "./ClientResourceModal.vue?vue&type=template&id=5aa777c5"
import script from "./ClientResourceModal.vue?vue&type=script&lang=js"
export * from "./ClientResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientResourceModal.vue"]])

export default __exports__